import React, { FC } from 'react';

import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { CertificateSubmission } from '../../model';

interface CertificateSubmissionFieldsProps {
  certificateSubmission: CertificateSubmission;
}

const CertificateSubmissionFields: FC<CertificateSubmissionFieldsProps> = (props) => {
  let { certificateSubmission } = props;

  return (
    <Card style={{ padding: '2%' }}>
      <Grid container>
        <Grid item xs={12}>
          <Typography>
            <span style={{ fontWeight: 'bold' }}>Customer: </span>
            {certificateSubmission?.customer?.name}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography>
            <span style={{ fontWeight: 'bold' }}>Project Name: </span>
            {certificateSubmission?.submission_name}
          </Typography>
        </Grid>
      </Grid>
    </Card>
  );
};

export default CertificateSubmissionFields;
